import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Button from '../../Atoms/Button';
import Promo from '../../Organisms/Promo';
import BlockImageCenter from '../../Organisms/BlockImageCenter';

import bgScan from '../../../assets/img/trackscan-header.jpg';
import robot from '../../../assets/img/robot.png';
import candidate3 from '../../../assets/img/candidate-remon-big.webp';
import CardSimple from '../../Molecules/CardSimple';

function Scan() {
  return (
    <>
      <div>
        <Promo
          bgImg={bgScan}
          bgPosition="center"
          bgSize="cover"
        >
          <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-7 sm:flex-row md:gap-14 lg:py-24 lg:px-10">
            <div className="flex w-full flex-col items-center justify-between gap-7 text-center">
              <Title color="white" as="h1">
                Dé Banenscan voor Monteurs Technische Dienst
              </Title>
              <Text
                color="white"
                size="lg"
                font="circular"
                className="mb-3.5"
              >
                Vind jouw droombaan in slechts 2 minuten!
              </Text>
              <Button
                shadow
                color="accent"
                text="Doe de banenscan"
                iconName="chevron-right"
              />
            </div>
          </div>
        </Promo>
      </div>
      <div className="bg-white py-10 lg:py-20">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-14 px-7 lg:gap-24">
          <CardSimple imageSrc={candidate3}>
            <Text
              size="lg"
              font="circular"
              color="blue-dark"
            >
              Kies voor keuze!
            </Text>
            <Title as="h2" color="blue-dark">
              Verdien jij wel genoeg?
            </Title>
            <Text
              className="mb-3.5 text-opacity-75"
              color="blue-dark"
            >
              <span>
                <strong>
                  Verdien jij wel zoals je zou moeten
                  verdienen bij je huidige baan?
                </strong>{' '}
                Dat is een vraag die helaas vaak met “Nee”
                beantwoord wordt. Daarom gaan we samen
                opzoek naar een baan die écht bij je past,
                jij staat centraal. Met keuze uit meer dan
                2500 werkgevers biedt Synsel Techniek de
                meeste banen voor Monteurs Technische
                Dienst.
              </span>
            </Text>
            <Button
              text="Doe de banenscan"
              iconName="chevron-right"
              color="accent"
              shadow
            />
          </CardSimple>

          <CardSimple
            theme="dark"
            reverse
            imageSrc={candidate3}
          >
            <Title as="h2" color="white">
              Zit jij op je plek bij je huidige baan?
            </Title>
            <Text className="mb-3.5" color="white">
              Een derde van jouw leven breng je werkend
              door. Dat is nogal wat. Laten we dan zorgen
              dat jouw werk als Monteurs Technische Dienst
              avontuurlijk is, bij een werkgever waar jij
              jezelf kan zijn. Alleen zo komt jouw
              vakmanschap echt tot zijn recht en bouw je
              verder aan jouw carrière.
            </Text>
            <Button
              text="Doe de banenscan"
              iconName="chevron-right"
              color="accent"
              shadow
            />
          </CardSimple>
        </div>
      </div>
      <div className="md:px-7">
        <div
          className="w-full overflow-hidden py-10 md:rounded-xl md:py-20"
          style={{
            backgroundImage:
              'linear-gradient(135deg, rgba(35, 39, 91, 0.05) 0%, rgba(35, 39, 91, 0.02) 100%)'
          }}
        >
          <div className="mx-auto w-full max-w-7xl px-7">
            <Title
              as="h2"
              size={2}
              className="mb-5 text-center"
            >
              Daarom doe je als Monteur Technische Dienst
              een beroep op ons:
            </Title>
            <BlockImageCenter
              image={robot}
              leftSide={[
                {
                  title: 'De beste volgende stap',
                  text: 'Met een brede keuze uit banen kiezen we met elkaar de carrièrestap waarmee je bouwt aan jouw toekomst.',
                  icon: 'rocket-regular'
                },
                {
                  title: 'De beste voorwaarden',
                  text: 'Een goed salaris, prettige werksfeer en een goed bereikbare locatie: de beste baan voor jou heeft ook de beste voorwaarden.',
                  icon: 'file-contract-regular'
                },
                {
                  title: 'Altijd vaste banen',
                  text: 'Echt bouwen aan jouw carrière doe je door te investeren in je toekomst met een vaste baan.',
                  icon: 'lock-keyhole-regular'
                }
              ]}
              rightSide={[
                {
                  title: '673 innovatieve werkgevers',
                  text: 'Door ons uitgebreide netwerk bieden we jou als Monteurs Technische Dienst de grootste keuze aan als het gaat om werkgevers.',
                  icon: 'handshake-regular'
                },
                {
                  title: 'Werken met specialisten',
                  text: 'Bij Synsel Techniek verstaan we jouw technische vak. We kennen de markt, spreken jouw taal en weten wat er speelt.',
                  icon: 'user-shield-regular'
                },
                {
                  title: 'Jij staat voorop',
                  text: 'Niet de werkgever maar jij staat voorop. Wij geloven erin dat als jij excelleert in jouw vak, onze klanten het meest tevreden zijn.',
                  icon: 'screwdriver-wrench-regular'
                }
              ]}
            />
          </div>
        </div>
      </div>

      <div className="bg-white py-10 lg:py-20">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-14 px-7 lg:gap-24">
          <CardSimple theme="dark" imageSrc={candidate3}>
            <Title as="h2" color="inherit">
              Jij staat centraal!
            </Title>
            <Text className="mb-3.5" color="inherit">
              We helpen jou om de juiste baan te vinden die
              aansluit op je wensen en behoeften. Jij
              vertelt wat je wilt en zoekt en wij selecteren
              voor jou de best passende bedrijven.
            </Text>
            <Button
              text="Doe de banenscan"
              iconName="chevron-right"
              color="accent"
            />
          </CardSimple>
        </div>
      </div>
    </>
  );
}

export default Scan;
